export const labels = {
	title: {
		label: "Label.MobileCreator.ErrorTooManyPhotos.Title",
		default: "Can't upload so many photos",
	},
	message: {
		label: "Label.MobileCreator.ErrorTooManyPhotos.Message",
		default: "Please select no more than {0} photos",
		// 0: max number of photos which can be selected by the user
	},
	close: {
		label: "Label.MobileCreator.ErrorTooManyPhotos.Close",
		default: "Ok",
	},
} as const;
